import React, { FC } from 'react';
import CheckedItem from '../CheckedItem';

interface Props {
  tableCols: any;
  columnConfig: any;
  onCheckBoxClick: (event: any) => void;
}

const CheckedContainer: FC<Props> = (props: Props) => {
  const { tableCols, columnConfig, onCheckBoxClick } = props;

  return (
    <div>
      {tableCols
        .filter((col: any) => columnConfig[col])
        .map((column: any, index: any) => (
          <CheckedItem
            key={`item-${column}`}
            index={index}
            column={column}
            tableCols={tableCols}
            columnConfig={columnConfig}
            onCheckBoxClick={onCheckBoxClick}
          />
        ))}
    </div>
  );
};

export default CheckedContainer;
try {
    // @ts-ignore
    CheckedContainer.displayName = "CheckedContainer";
    // @ts-ignore
    CheckedContainer.__docgenInfo = { "description": "", "displayName": "CheckedContainer", "props": { "tableCols": { "defaultValue": null, "description": "", "name": "tableCols", "required": true, "type": { "name": "any" } }, "columnConfig": { "defaultValue": null, "description": "", "name": "columnConfig", "required": true, "type": { "name": "any" } }, "onCheckBoxClick": { "defaultValue": null, "description": "", "name": "onCheckBoxClick", "required": true, "type": { "name": "(event: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ExportAudienceList/components/CheckedContainer/CheckedContainer.tsx#CheckedContainer"] = { docgenInfo: CheckedContainer.__docgenInfo, name: "CheckedContainer", path: "src/shared/components/ExportAudienceList/components/CheckedContainer/CheckedContainer.tsx#CheckedContainer" };
}
catch (__react_docgen_typescript_loader_error) { }